import React, { useEffect, useState } from "react";
import { Row, Card, Col } from "react-bootstrap";
import imgurl from "../assets/images/imgurl";
import axios from "axios";

function TopIndicators({ requestData }) {
  const [totalIndicators, setTotalIndicators] = useState(0);
  const [closeCase, setCloseCase] = useState(0);
  const [openCase, setOpenCase] = useState(0);
  const [validatedCase, setvalidatedCase] = useState(0);
  const [deactivatedCase, setDeactivatedCase] = useState(0);
  const [escalatedCase, setEscalatedCase] = useState(0);
  const [declinedCase, setDeclinedCase] = useState(0);

  useEffect(() => {
    let requestBody = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      caseStatusList: [
        "Open",
        "Validated",
        "Resolved",
        "Deactivate",
        "Escalated",
        "Declined",
      ],
    };
    if (Object.keys(requestData).length > 0) {
      let oRequest = { ...requestBody, ...requestData };
      if (
        (requestData?.globalFilters?.dateFilter.to !== "" &&
          requestData?.globalFilters?.dateFilter.from !== "") ||
        (requestData.questionIds != null &&
          requestData.selectedOption != null) ||
        (requestData.subQuestionIds != null &&
          requestData.selectedOption != null) ||
        requestData.serviceIdFilter != null
      ) {
        getTopIndicatorData(oRequest);
      }
    } else {
      getTopIndicatorData(requestBody);
    }
  }, [requestData]);

  let getTopIndicatorData = async (data) => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/getCasesCountByStatus`,
        data
      );
      casesReported(res.data.data.caseStatusCount);
      setCloseCase(res.data.data.caseStatusCount.Resolved);
      setOpenCase(res.data.data.caseStatusCount.Open);
      setvalidatedCase(res.data.data.caseStatusCount.Validated);
      setDeactivatedCase(res.data.data.caseStatusCount.Deactivate);
      setEscalatedCase(res.data.data.caseStatusCount.Escalated);
      setDeclinedCase(res.data.data.caseStatusCount.Declined);
    } catch (error) {
      console.log(error);
    }
  };

  const casesReported = (data) => {
    let values = Object.values(data);
    const sumWithIndictors = values.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    setTotalIndicators(sumWithIndictors);
  };

  const getPercent = (value) => {
    if (value == 0 || totalIndicators == 0) {
      return 0;
    } else {
      return Math.round((value / totalIndicators) * 100);
    }
  };

  return (
    <Row className="indicator-section row-cols-7">
      <Col className="pr-0px pl-0">
        <Card>
          <Card.Body>
            <div className="d-flex align-items-center justify-content-center">
              <div className="indic-img">
                <img className="" src={imgurl.graphicon} />
              </div>
              <div className="mx-3">
                <p className="stat-cards-info__title">Cases reported</p>
                <p className="stat-cards-info__num">{totalIndicators}</p>
                <span>({getPercent(closeCase)}%)</span>
              </div>
            </div>
            {/* <div className="mx-3">
                    
                    </div> */}
          </Card.Body>
        </Card>
      </Col>
      <Col className="pr-0px pl-0">
        <Card>
          <Card.Body>
            <div className="d-flex align-items-center justify-content-center">
              <div className="indic-img">
                <img className="" src={imgurl.verifyicon} />
              </div>
              <div className="mx-3">
                <p className="stat-cards-info__title">Closed cases</p>
                <p className="stat-cards-info__num blue-indic">{closeCase}</p>
                <span>({getPercent(closeCase)}%)</span>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col className="pr-0px pl-0">
        <Card>
          <Card.Body>
            <div className="d-flex align-items-center justify-content-center">
              <div className="indic-img">
                <img className="" src={imgurl.openicon} />
              </div>
              <div className="mx-3">
                <p className="stat-cards-info__title">Open cases</p>
                <p className="stat-cards-info__num green-indic">{openCase}</p>
                <span>({getPercent(openCase)}%)</span>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col className="pr-0px pl-0">
        <Card>
          <Card.Body>
            <div className="d-flex align-items-center justify-content-center">
              <div className="indic-img">
                <img className="" src={imgurl.checkicon} />
              </div>
              <div className="mx-3">
                <p className="stat-cards-info__title">Validated</p>
                <p className="stat-cards-info__num">{validatedCase}</p>
                <span>({getPercent(validatedCase)}%)</span>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col className="pr-0px pl-0">
        <Card>
          <Card.Body>
            <div className="d-flex align-items-center justify-content-center">
              <div className="indic-img">
                <img className="" src={imgurl.crossicon} />
              </div>
              <div className="mx-3">
                <p className="stat-cards-info__title">Deactivated</p>
                <p className="stat-cards-info__num red-indic">
                  {deactivatedCase}
                </p>
                <span>({getPercent(deactivatedCase)}%)</span>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col className="pr-0px pl-0">
        <Card>
          <Card.Body>
            <div className="d-flex align-items-center justify-content-center">
              <div className="indic-img">
                <img className="" src={imgurl.escalated} />
              </div>
              <div className="mx-3">
                <p className="stat-cards-info__title">Escalated</p>
                <p className="stat-cards-info__num red-indic">
                  {escalatedCase}
                </p>
                <span>({getPercent(escalatedCase)}%)</span>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col className="pr-0px pl-0">
        <Card>
          <Card.Body>
            <div className="d-flex align-items-center justify-content-center">
              <div className="indic-img">
                <img className="" src={imgurl.declined} />
              </div>
              <div className="mx-3">
                <p className="stat-cards-info__title">ON Hold</p>
                <p className="stat-cards-info__num red-indic">{declinedCase}</p>
                <span>({getPercent(declinedCase)}%)</span>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default TopIndicators;
